import React from 'react';
import { getImageUrl } from '../services/api';

function DetectionPreview({ result, isProcessing }) {
  if (isProcessing) {
    return (
      <div className="detection-preview card">
        <h3 className="card-title">AI Detection Preview</h3>
        <div className="preview-placeholder">
          <div className="shimmer-box"></div>
        </div>
      </div>
    );
  }

  if (!result) return null;

  const objectCounts = {};
  (result.detectedObjects || []).forEach(obj => {
    objectCounts[obj.label] = (objectCounts[obj.label] || 0) + 1;
  });

  return (
    <div className="detection-preview card">
      <div className="card-header">
        <h3 className="card-title">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
            <path d="M1 1h5v2H3v3H1V1zm11 0h5v5h-2V3h-3V1zM1 12h2v3h3v2H1v-5zm14 3h-3v2h5v-5h-2v3z"/>
          </svg>
          AI Detection Preview
        </h3>
        <span className="processing-time">{result.processingTimeMs}ms</span>
      </div>

      <div className="annotated-image-container">
        <img
          src={getImageUrl(result.annotatedImage)}
          alt="Annotated inspection result"
          className="annotated-image"
        />
      </div>

      <div className="detection-summary">
        <h4>Detected Objects</h4>
        <div className="object-tags">
          {Object.entries(objectCounts).map(([label, count]) => {
            let tagClass = 'tag-info';
            if (label.includes('Missing')) tagClass = 'tag-danger';
            else if (label === 'Helmet' || label === 'Safety Vest') tagClass = 'tag-success';
            else if (label === 'Person') tagClass = 'tag-primary';

            return (
              <span key={label} className={`object-tag ${tagClass}`}>
                {label} {count > 1 ? `x${count}` : ''}
              </span>
            );
          })}
        </div>
      </div>

      <div className="detection-table">
        <table>
          <thead>
            <tr>
              <th>Object</th>
              <th>Confidence</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {(result.detectedObjects || []).map((obj, i) => (
              <tr key={i}>
                <td>{obj.label}</td>
                <td>{Math.round(obj.confidence * 100)}%</td>
                <td>
                  <span className={`status-chip status-${obj.complianceStatus}`}>
                    {obj.complianceStatus}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DetectionPreview;
